import React, { useState } from "react";
import { Wrapper, Container } from "./style";
import Content from "./components/Content";
import Header from "../components/Header";
import { MODAL_MEND } from "store/Modals/constants";

const MendModal = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Wrapper>
      <Container expanded={expanded}>
        <Header expanded={expanded} setExpanded={setExpanded} modal={MODAL_MEND} />
        <Content expanded={expanded} />
      </Container>
    </Wrapper>
  );
};

export default MendModal;
